const initial = {
  loading: true,
}

export default {
  transactions: initial,
  transactionsMeta: {},
  debitTransactions: initial,
  creditTransactions: initial,
  futureTransactions: initial,
  walletSummary: initial,
  amountToReceive: initial,
  cashbackAmountToReceive: initial,
  walletUpdatedAt: null,
  externalToken: initial,
  lastDraw: {},
  transactionsLoadeds: [],
  bonusReceived: initial,
  pixKeysAccount: null,
  listPixKey: null,
  chosenOwner: null,
  userDataTransfer: null,
  attemptRegisterPhone: 0,
  pix_amount_credited: 0,
  walletDetails: null,
  phoneWalletInfo: initial,
}
